// extracted by mini-css-extract-plugin
export var fadeInDown = "styles-module--fadeInDown--a37db";
export var firstGlow = "styles-module--first-glow--eeb6d";
export var showMoreIcon = "styles-module--showMore-icon--26527";
export var showMoreText = "styles-module--showMore-text--74627";
export var showMoreWrapper = "styles-module--showMore-wrapper--ae57d";
export var suptitle = "styles-module--suptitle--e27e7";